import { render, staticRenderFns } from "./productionlist.vue?vue&type=template&id=47736162"
import script from "./productionlist.vue?vue&type=script&lang=js"
export * from "./productionlist.vue?vue&type=script&lang=js"
import style0 from "./productionlist.vue?vue&type=style&index=0&id=47736162&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports